import { Play } from 'lucide-react'
import { Link } from 'react-router-dom'

import type { DeletedPost, Post } from '@/api/types'
import { isDeleted } from '@/api/types'
import { Avatar } from '@/components/ui/Avatar'
import { useT } from '@/i18n'
import { formatDuration, useFormat } from '@/lib/format'

/** 被引用的帖子：嵌一层即止，内部不再展开引用。 */
export function QuoteCard({ post }: { post: Post | DeletedPost }) {
  const { relativeTime } = useFormat()
  const t = useT()
  if (isDeleted(post)) {
    return (
      <div className="mt-3 rounded-md border border-line px-3 py-3 text-[15px] text-ink-muted">
        {post.protected ? t('protected.quoted') : t('quote.deleted')}
      </div>
    )
  }

  return (
    <Link
      to={`/${post.author.username}/status/${post.id}`}
      onClick={(event) => event.stopPropagation()}
      className="mt-3 block overflow-hidden rounded-md border border-line hover:bg-surface-hover"
    >
      <div className="px-3 pt-3">
        <div className="flex items-center gap-1 text-[15px]">
          <Avatar
            src={post.author.avatar_url}
            alt={post.author.display_name}
            size="xs"
            className="size-5"
          />
          <span className="font-bold">{post.author.display_name}</span>
          <span className="text-ink-muted">@{post.author.username}</span>
          <span className="text-ink-muted">·</span>
          <span className="text-ink-muted">{relativeTime(post.created_at)}</span>
        </div>
        {post.content && <p className="post-text mt-1 text-[15px]">{post.content}</p>}
      </div>

      {post.media.length > 0 && (
        <div className="relative mt-2">
          <img
            src={
              (post.media[0].kind === 'video'
                ? post.media[0].poster_url
                : (post.media[0].thumb_url ?? post.media[0].url)) ?? undefined
            }
            alt={post.media[0].alt_text ?? ''}
            loading="lazy"
            className="max-h-72 w-full object-cover"
          />
          {post.media[0].kind === 'video' && (
            <span className="absolute bottom-2 left-2 inline-flex items-center gap-1 rounded bg-black/70 px-1.5 py-0.5 font-mono text-[12px] font-bold text-white">
              <Play className="size-3" fill="currentColor" aria-hidden />
              {formatDuration(post.media[0].duration_ms)}
            </span>
          )}
        </div>
      )}
      {post.media.length === 0 && <div className="pb-3" />}
    </Link>
  )
}
